<template>
    <or-layout>
        <a-form layout="inline">
            <a-form-item>
                <a-select show-search optionFilterProp="children" v-model="form.admin_id" placeholder="班主任"
                    style="width: 200px;" allow-clear>
                    <a-select-option v-for="(item) in teacherList" :key="item.id" :value="item.id">{{ item.nickname
                    }}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-input v-model="form.title" placeholder="请输入查询标题" @keyup.enter="getTableList"></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" htmlType="submit" icon="search" @click="getTableList"></a-button>
            </a-form-item>
        </a-form>
        <a-table :dataSource="data" :rowKey="item => item.id" @change="onPaginationChange" bordered :pagination="pageinfo">
            <a-table-column key="nickname" title="姓名">
                <template slot-scope="item">{{ item.admin.nickname }}</template>
            </a-table-column>
            <a-table-column key="campus_name" title="校区">
                <template slot-scope="item">
                    <span v-if="item.squad">{{ item.squad.campus_name }}</span>
                    <span v-else>暂无校区信息</span>
                </template>
            </a-table-column>
            <a-table-column key="class_id" title="年/班级">
                <template slot-scope="item">
                    <span v-if="item.squad">{{ item.squad.grade_name + '/' + item.squad.name }}</span>
                    <span v-else>暂无年级信息</span>
                </template>
            </a-table-column>
            <a-table-column key="title" title="标题" data-index="title" />
            <a-table-column key="user_id" title="学生ID" data-index="user_id" />
            <a-table-column key="chapter_name" title="章节名称" data-index="chapter_name" />
            <a-table-column key="remark" title="备注" data-index="remark" />
            <a-table-column key="status" title="状态" data-index="status" />
            <a-table-column key="create_time" title="浏览日期" data-index="create_time" />
            <a-table-column key="browsing_time" title="停留时间">
                <template slot-scope="item">
                    {{ dateFormate(item.browsing_time) }}
                </template>
            </a-table-column>
            <a-table-column key="active" width="280px" title="操作">
                <template slot-scope="item">
                    <a-popconfirm title="确定要删除吗?" ok-text="确认" cancel-text="取消" @confirm="deleteRecord(item.id)">
                        <a>删除</a>
                    </a-popconfirm>
                    <teacher-record :id="item.admin_id" />
                </template>
            </a-table-column>
        </a-table>
    </or-layout>
</template>

<script>
export default {
    data() {
        return {
            data: [],
            form: {
                admin_id: '',
                title: '',
            },
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            keywords: '',
            teacherList: [],
            gradeList: []
        }
    },
    created() {
        this.getAdminList()
        this.getTableList()
    },
    methods: {
        deleteRecord(id) {
            this.$axios.post('/api/AccessLog/dell', {
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 200) {
                    this.data = this.data.filter(item => item.id !== id)
                }
            }).catch(error => {

            })
        },
        dateFormate(number) {
            let time = Number(number)
            if (time < 60) {
                return time + '秒'
            } else if (time >= 60 && time < 3600) {
                return parseInt(time / 60) + '分' + time % 60 + '秒'
            } else if (time >= 3600 && time < 86400) {
                return parseInt(time / 3600) + '时' + parseInt((time % 3600) / 60) + '分' + time % 60 + '秒'
            } else {
                return parseInt(time / 86400) + '天' + parseInt((time % 86400) / 3600) + '时' + parseInt((time % 86400) / 60) + '分' + time % 60 + '秒'
            }
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },
        getTableList() {
            this.$axios.post('/api/AccessLog/list', {
                data: {
                    admin_id: this.form.admin_id,
                    title: this.form.title
                },
                pageinfo: this.pageinfo
            }).then(res => {
                this.data = res.data.data;
                this.pageinfo = res.data.pageinfo
            }).catch(error => {

            })
        },
        getAdminList() {
            this.$axios.post("/api/admin/index", {
                data: {
                    keywords: this.keywords
                },
                pageinfo: { total: 1, current: 1, pageSize: 999 }
            }).then((res) => {
                if (res.code != 200) {
                    this.$error({
                        title: "错误",
                        content: res.msg,
                        okText: "确定",
                    });
                } else {
                    this.teacherList = res.data.data;
                }
            }).catch((err) => {
                console.error(err);
            });
        }
    }
}
</script>

<style lang="less" scoped></style>